// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "58ba15b0dba7f70e237600b997288db19ae0fb5f/static/css/" + chunkId + "." + "9ae35b6f" + ".chunk.css";
};